export const environment = {
  production: false,
  serverApiUrl: 'https://api.fdels.com/',
  kafkaUrl: 'http://34.29.27.34:8080'
};
